<template>
	<div>
		<div class="changePassBody">
			<h1>修改密码</h1>
			<div class="changePassBox">
				<div class="changePassItem">
					<span>旧密码：</span>
					<el-input v-model="passwordold" placeholder="请输入旧密码"></el-input>
				</div>
				<div class="changePassItem">
					<span>新密码：</span>
					<el-input v-model="passwordnew" placeholder="请输入新密码"></el-input>
				</div>
				<div class="changePassItem">
					<span>重复新密码：</span>
					<el-input v-model="repasswordnew" placeholder="请输入新密码"></el-input>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
  name: 'changePass',
  data () {
    return {
 		passwordold:'',
 		passwordnew:'',
 		repasswordnew:''
    }
   },
   created:function(){
   	var _this=this;
   },
    methods:{
    	getOrderBuyFromList:function(){
    		var _this = this;
				$.ajax({
					type: "post",
					url: _this.$store.state.getUrl + "api/sell/getOrderBuyFromList",
					data: JSON.stringify({
						"token": _this.$store.getters.getStorage
					}),
					dataType: "json",
					crossDomain: true == !(document.all),
					contentType: "application/json",
					success: function(data) {
						if(data.ret == 10000) {
							//_this.fromOptions=data.result.list;
							for(var i in data.result.list){
								_this.fromOptions.push({value:data.result.list[i].buyFromName,label:data.result.list[i].buyFromName})
							}
							console.log(_this.fromOptions)
						}
					}
				});
    },
    },
    mounted:function(){
    	var _this=this;	
    },
	beforeRouteEnter (to, from, next) {
    if (to.matched.some(m => m.meta.auth)) {
	    if (window.localStorage.isLogin === '1') {
	      next()
	    } else{
	      next({path: '/login'})
	      Vue.prototype.$message.warning('检测到您还未登录,请登录后操作！')
	    }
	  } else {
	    next()
	  }
	}
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/changePass.vue